module.exports = __webpack_public_path__ + "img/pointF_item3.4ea06a77.png";